const UPDATE_EXISTS = 'UPDATE_EXISTS'
const START_RELOAD = 'START_RELOAD'
const CLEAR_UPDATE = 'CLEAR_UPDATE'
const SKIP_WAITING = 'SKIP_WAITING'

const initialState = {
  refreshing: false,
  registration: null,
  updateExists: false
}

const state = { ...initialState }

const mutations = {
  [UPDATE_EXISTS]: function (state, registration) {
    state.registration = registration
    state.updateExists = true
  },
  [START_RELOAD]: function (state) {
    state.refreshing = true
  },
  [CLEAR_UPDATE]: function (state) {
    state.updateExists = false
  },
  [SKIP_WAITING]: function (state) {
    if (!state.registration || !state.registration.waiting) { return }
    state.registration.waiting.postMessage('skipWaiting')
  }
}

const actions = {
  newUpdate ({ commit }, registration) {
    commit(UPDATE_EXISTS, registration)
  },
  clearUpdate ({ commit }) {
    commit(CLEAR_UPDATE)
  },
  startReload ({ commit }) {
    commit(START_RELOAD)
  },
  skipWaiting ({ commit, dispatch }) {
    dispatch('clearUpdate')
    commit(SKIP_WAITING)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
